import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import { UserModule } from '@/store/modules/user'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useSegment from '@/composables/useSegment'
  import { useRouter } from 'vue-router/composables'
  import useCourse from '@/composables/useCourse'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LastUserActivity',
  setup(__props) {

  const router = useRouter()

  const { courseSectionsAssignedCourses } = useCourse()
  const { arrowRightIndicator } = useIcons()
  const { routeToLastAccessedLessonClicked } = useSegment()

  const lastUserCourseLog = computed(() => UserModule.lastUserCourseLog)

  const lastAccessedCourse = computed(() =>
    courseSectionsAssignedCourses.value?.find((c) => c.id === lastUserCourseLog.value?.courseId),
  )

  const routeToLastAccessedLesson = async () => {
    await routeToLastAccessedLessonClicked(UserModule.email)
    router
      .push({
        name: 'Lesson',
        params: {
          courseId: lastUserCourseLog.value!.courseId,
          moduleId: lastUserCourseLog.value!.moduleId,
          lessonId: lastUserCourseLog.value!.lessonId,
        },
      })
      .catch(() => {
        return
      })
  }

  if (UserModule.hasValidUser) {
    UserModule.setUserLastCourseLog()
  }

return { __sfc: true,router, courseSectionsAssignedCourses, arrowRightIndicator, routeToLastAccessedLessonClicked, lastUserCourseLog, lastAccessedCourse, routeToLastAccessedLesson, computed, UserModule, SVGRenderer, useIcons, useSegment, useRouter, useCourse }
}

})